package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_02_01_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-02-01")
@Composable
public fun Log_2025_02_01(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Friends of the Forest",
        ogTitle = "Friends of the Forest",
        date = LocalDate(2_025, 2, 1),
        ogDescription = "Entor empowers the heroes to defeat Do’Shara also known as Samuel Thardos, Duke of Brij.",
        ogImage = "ai/2025-02-01.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-74", dateString = "Newgrowth 74")
        Log_2025_02_01_Day_1()
    }
}
